import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { translateKey } from 'src/locales/translate';


interface ProfileTreatmentDeleteModalProps {
  isOpen: boolean;
  isLoading: boolean;
  handleClose: () => void;
  onDelete: () => void;
}

export default function ProfileTreatmentDeleteModal({
  isOpen,
  isLoading,
  handleClose,
  onDelete,
}: ProfileTreatmentDeleteModalProps) {
  return (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>{translateKey("hardcoded.usun_zabieg")}</DialogTitle>
      <DialogContent>
        <DialogContentText>{translateKey("hardcoded.czy_na_pewno_chcesz_usunac_ten_zabieg_powiazane")}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={handleClose}
          disabled={isLoading}
          variant="outlined"
          color="inherit"
        >{translateKey("common.cancel")}</Button>
        <LoadingButton
          onClick={onDelete}
          loading={isLoading}
          color="error"
          variant="contained"
          data-testid="treatment-delete-confirm"
        >{translateKey("common.remove")}</LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
